import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import { siteThemes, theme } from '../../utils/theming.js';
import { focusOutline } from '../../utils/mixins.js';
import Icon from '../Icon/Icon.js';

var validationColors = {
  validationErrorBg: '#facac7',
  validationErrorText: '#8f271f',
  validationErrorBorder: '#fd9e99',
  validationValid: '#1d9886'
};
var DEFAULT = siteThemes.DEFAULT,
  GLOBETROTTER = siteThemes.GLOBETROTTER;
var validIconFill = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["fill:", ";"], validationColors.validationValid)), GLOBETROTTER, css(["fill:none;"])));
var border = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["border:1px solid;border-radius:var(--border-radius-300);"])), GLOBETROTTER, css(["border-bottom:1px solid;border-radius:0;"])));
var focusBorder = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["", ""], focusOutline)), GLOBETROTTER, css(["border-color:var(--color-almostblack);border-bottom:2px solid;"])));
var getBorderColor = function getBorderColor(_ref) {
  var $hasError = _ref.$hasError,
    $isValid = _ref.$isValid;
  if ($hasError) return css(["var(--color-element-input-error)"]);
  if ($isValid) return css(["var(--color-element-input-success)"]);
  return css(["var(--color-border-primary)"]);
};
var TextInput = styled.input.withConfig({
  displayName: "style__TextInput",
  componentId: "sc-1lac78q-0"
})(["", " border-color:", ";box-sizing:border-box;display:block;font-family:var(--font-family-body);font-size:1.6rem;height:4.4rem;outline:none;padding:4px 15px;padding-right:", ";width:100%;position:relative;margin-top:6px;margin-bottom:16px;color:var(--color-text-subtle);&:focus{outline:none;box-shadow:none;", "}"], border, function (props) {
  return getBorderColor(props);
}, function (props) {
  return props.$isValid ? '35px' : '15px';
}, focusBorder);
var TextInputWrapper = styled.div.withConfig({
  displayName: "style__TextInputWrapper",
  componentId: "sc-1lac78q-1"
})(["position:relative;"]);
var ValidationText = styled.span.withConfig({
  displayName: "style__ValidationText",
  componentId: "sc-1lac78q-2"
})(["color:", ";background:", ";width:100%;display:inline-block;position:absolute;padding:10px;font-size:1.3rem;z-index:1;margin-top:-16px;&:before{content:'';position:absolute;top:-8px;left:10px;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:8px solid ", ";}"], validationColors.validationErrorText, validationColors.validationErrorBg, validationColors.validationErrorBg);
var TextInputIcon = styled(Icon).withConfig({
  displayName: "style__TextInputIcon",
  componentId: "sc-1lac78q-3"
})(["", " position:absolute;top:14px;right:15px;display:flex;justify-content:center;flex-direction:column;text-align:center;"], validIconFill);

export { TextInput, TextInputIcon, TextInputWrapper, ValidationText };
//# sourceMappingURL=style.js.map
